/**
  Success = 0,
  [Description("Unexpected error encountered")]
  GeneralError = 100,
  [Description("Requested resource was not found")]
  ResourceNotFound = 101,
  [Description("Login failed, please Sign In again")]
  LoginFailed = 200,
  [Description("Specified user account is no longer active")]
  UserAccountDisabled = 201,
  [Description("UserAccount has already been created using the specified username")]
  UserNameAlreadyExists = 210,
  LoginFailedPassword = 203,
  SessionExpired = 204,
  TouchIdLoginFailed = 205,
  [Description("Expecting security token but did not find one")]
  SecurityTokenNotFound = 400,
  [Description("Invalid security token passed")]
  SecurityTokenInvalid = 401,
  PromptUser = 600,
  [Description("Please Sign On")]
  SignOnRequired = 700,
  [Description("Specified device is no longer active")]
  DeviceDisabled = 701,
  [Description("Invalid module code passed")]
  InvalidModuleCode = 801,
  [Description("Specified module not enabled.")]
  ModuleNotEnabled = 802,
  [Description("Specified api version not supported.")]
  ApiVersionNotSupported = 810
 */

export const DATA_RESPONSE_CODE = {
  SUCCESS: 0,
  //100s
  GENERAL_ERROR: 100,
  RESOURCE_NOT_FOUND: 101,
  //200s
  LOGIN_FAILED: 200,
  USER_ACCOUNT_DISABLED: 201,
  USER_NAME_ALREADY_EXISTS: 210,
  LOGIN_FAILED_PASSWORD: 203,
  SESSION_EXPIRED: 204,
  TOUCH_ID_LOGIN_FAILED: 205,
  //400s
  SECURITY_TOKEN_NOT_FOUND: 400,
  SECURITY_TOKEN_INVALID: 401,
  //600s
  PROMPT_USER: 600,
  //700s
  SIGN_ON_REQUIRED: 700,
  DEVICE_DISABLED: 701,
  //800s
  INVALID_MODULE_CODE: 801,
  MODULE_NOT_ENABLED: 802,
  API_VERSION_NOT_SUPPORTED: 810,
};
